import axios from 'axios';
import { Constants } from './constants';
import { IConfig } from './contract/config.contract';

(async () => {
  const response = await axios.get<IConfig>('config.json');
  Constants.init(response.data);
  // Set the public path dynamically so it can be changed depending on where the app is deployed
  // eslint-disable-next-line @typescript-eslint/camelcase
  __webpack_public_path__ = `${Constants.PublicPath}/`;
  import('@/app.ts');
})();
